import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Form,
  Col,
  Button,
} from "reactstrap";
import { useFormik } from "formik";
import { ErrorToaster } from "components/common/toast";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { ResetPasswordApi } from "network/user";
import InputPassword from "components/common/input-password";
import PATHS from "constant/paths";
import { useTranslation } from "react-i18next";
import BtnCustom from "components/common/btn-custom";
import handleError from "utils/handleError";
import { ResetPasswordConfirm } from "network/user";
import { ShowLoadingScreen } from "components/common/Loading";
import { successToaster } from "components/common/toast";
import { ResetPasswordSchema } from "components/schema/ResetPasswordSchema";

const PasswordReset = () => {
  const { t } = useTranslation("auth");
  const navigate = useNavigate();
  const { id, token } = useParams();
  const [loading, setLoading] = useState(true);
  const [userToken, setUserToken] = useState(null);

  const fetchToken = async () => {
    try {
      const response = await ResetPasswordConfirm(id, token);
      if (response.success) {
        setUserToken(response?.data);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id && token) {
      fetchToken();
    } else {
      navigate(PATHS.LOGIN);
    }
  }, [id, token]);

  const {
    errors,
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    touched,
    isSubmitting,
  } = useFormik({
    initialValues: {
      password: "",
      confirm_password: "",
    },
    enableReinitialize: true,
    validationSchema: ResetPasswordSchema,

    onSubmit: async (values) => {
      const body = {
        password: values.password,
        confirm_password: values.confirm_password,
        user_id: userToken?.user_id,
        token: userToken?.token,
      };
      try {
        const response = await ResetPasswordApi(body);
        if (response.success) {
          successToaster(t("reset.success"));
          navigate(PATHS.LOGIN);
        }
      } catch (error) {
        ErrorToaster(handleError(error?.status_code, error?.message));
        navigate(PATHS.FORGOT_PASSWORD);
      }
    },
  });
  if (loading) {
    return <ShowLoadingScreen />;
  }
  return (
    <>
      {userToken?.user_id && userToken?.token ? (
        <div className="content reset-password">
          <Col className="ml-auto mr-auto" lg="4" md="6">
            <Form className="form" onSubmit={handleSubmit}>
              <Card className="card-login card-white">
                <CardHeader>
                  <img alt="..." src={require("assets/img/card-primary.png")} />
                  <CardTitle tag="h6">{t("reset.title")}</CardTitle>
                </CardHeader>
                <CardBody>
                  <InputPassword
                    icon={<i className="tim-icons icon-lock-circle" />}
                    name="password"
                    placeholder={t("reset.newPassword")}
                    type="password"
                    errors={errors}
                    touched={touched}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values}
                  />
                  <InputPassword
                    icon={<i className="tim-icons icon-lock-circle" />}
                    name="confirm_password"
                    placeholder={t("reset.confirmPassword")}
                    type="password"
                    errors={errors}
                    touched={touched}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values}
                  />
                </CardBody>
                <CardFooter>
                  <BtnCustom
                    block
                    className="mb-3"
                    color="primary"
                    size="lg"
                    type="submit"
                    isLoading={isSubmitting}
                    submittingText={t("reset.setting")}
                  >
                    {t("reset.submit")}
                  </BtnCustom>
                </CardFooter>
              </Card>
            </Form>
          </Col>
        </div>
      ) : (
        <div className="content token_msg text-center">
          <p className="pb-3">{t("reset.expired")}</p>
          <Button
            color="primary"
            onClick={() => navigate(PATHS.FORGOT_PASSWORD)}
          >
            {t("reset.tryAgain")}
          </Button>
        </div>
      )}
    </>
  );
};

export default PasswordReset;
